import { 
  Component,
  OnInit
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { CustomValidator } from '../../utilities/validator/custom-validator';
import { Toastr } from '../../plugins/toastr/toastr';
import * as moment from 'moment';

@Component({
  templateUrl: 'forgot.component.html'
})
export class ForgotComponent implements OnInit {

  public success: boolean = false;
  forgotPasswordForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  public date: any = new Date();
  public year: any;

  constructor(
    private formBuilder: FormBuilder,
    public toastr: Toastr,
    public authService: AuthenticationService,
  ) {
    this.year = moment(this.date).format('YYYY');
   }



  ngOnInit(){
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [
        Validators.required,
        CustomValidator.email
      ]]
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.forgotPasswordForm.controls; }

  ngOnDestroy() { }

  submit(){
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      console.log('error');
      return;
    }

    this._startLoading();
    this.authService.forgotPassword(this.forgotPasswordForm.value).subscribe(
      res => {
        this._stopLoading();
        this.toastr.showSuccess('We have sent you an email with further procedure.');
        this.forgotPasswordForm.reset();
      },
      error => {
        this._stopLoading();
         console.log(error);
      });
  }

  _startLoading() {
    this.loading = true;
  }
  
  _stopLoading() {
    this.loading = false;
  }

}
